export type BasePayload = {
  url: string;
  deviceType: string;
  integrationType: string;
  productCardOrder: string;
  ep: string | undefined;
};

export type PostTracking = BasePayload & {
  eventType: EventType;
  eventParam: EventParam;
};

export enum EventType {
  PAGEVIEW = 'PageView',
  EVENT = 'Event',
}

export enum EventParam {
  LOAD = 'Load',
  VIEW = 'View',
  CLICK = 'Click',

  VIEW_AP = 'View-AP',
  VIEW_AL = 'View-AL',
  VIEW_AT = 'View-AT',
  VIEW_RI = 'View-RI',
  VIEW_SIM = 'View-SIM',
  VIEW_FT = 'View-FT',
  VIEW_HPM = 'View-HPM',
  VIEW_HPV = 'View-HPV',
  VIEW_CS = 'View-CS',

  CLICK_AP = 'CLICK-AP',
  CLICK_AL = 'CLICK-AL',
  CLICK_AT = 'CLICK-AT',
  CLICK_RI = 'CLICK-RI',
  CLICK_SIM = 'CLICK-SIM',
  CLICK_FT = 'CLICK-FT',
  CLICK_HPM = 'CLICK-HPM',
  CLICK_HPV = 'CLICK-HPV',
  CLICK_CS = 'CLICK-CS',

  CLICK_LNH_BKN = 'Click-LNH_BKN',
  CLICK_ZUG_BKN = 'Click-ZUG_BKN',
  CLICK_GRM_BKN = 'Click-GRM_BKN',
  CLICK_NST_BKN = 'Click-NST_BKN',
  CLICK_MCT_BKN = 'Click-MCT_BKN',
  CLICK_MCC_BKN = 'Click-MCC_BKN',
  CLICK_SXC_BKN = 'Click-SXC_BKN',
  CLICK_BNG_DWN = 'Click-BNG_DWN',
  CLICK_IGV_BKN = 'Click-IGV_BKN',
  CLICK_SXR_BKN = 'Click-SXR_BKN',
  CLICK_ROW_BKN = 'Click-ROW_BKN',
  CLICK_BHF_BKN = 'Click-BHF_BKN',
  CLICK_FMG_BKN = 'Click-FMG_BKN',

  CLICK_LNH_INF = 'Click-LNH_INF',
  CLICK_ZUG_INF = 'Click-ZUG_INF',
  CLICK_GRM_INF = 'Click-GRM_INF',
  CLICK_NST_INF = 'Click-NST_INF',
  CLICK_MCT_INF = 'Click-MCT_INF',
  CLICK_MCC_INF = 'Click-MCC_INF',
  CLICK_SXC_INF = 'Click-SXC_INF',
  CLICK_BNG_INF = 'Click-BNG_INF',
  CLICK_IGV_INF = 'Click-IGV_INF',
  CLICK_SXR_INF = 'Click-SXR_INF',
  CLICK_ROW_INF = 'Click-ROW_INF',
  CLICK_BHF_INF = 'Click-BHF_INF',
  CLICK_FMG_INF = 'Click-FMG_INF',
}

export type GA4TrackingEntry = {
  label: string;
  bkn: string;
  inf: string;
};

export type GA4ProductKey = keyof typeof GA4_TRACKING;

export const GA4_TRACKING: Record<string, GA4TrackingEntry> = {
  product01: { label: 'Leonardo_Hotels', bkn: 'LNH_BKN', inf: 'LNH_INF' },
  product02: { label: 'Zugspitze', bkn: 'ZUG_BKN', inf: 'ZUG_INF' },
  product03: { label: 'Garmisch', bkn: 'GRM_BKN', inf: 'GRM_INF' },
  product04: { label: 'Neuschwanstein', bkn: 'NST_BKN', inf: 'NST_INF' },
  product05: { label: 'MUC_Grand_Tours', bkn: 'MCT_BKN', inf: 'MCT_INF' },
  product06: { label: 'Munich_City_Pass', bkn: 'MCC_BKN', inf: 'MCC_INF' },
  product08: { label: 'Sixt_Rental_Car', bkn: 'SXC_BKN', inf: 'SXC_INF' },
  product09: { label: 'Breuninger', bkn: 'BNG_DWN', inf: 'BNG_INF' },
  product10: { label: 'MUC_Ingolstadt_Village', bkn: 'IGV_BKN', inf: 'IGV_INF' },
  product11: { label: 'SIXT_Ride', bkn: 'SXR_BKN', inf: 'SXR_INF' },
  product12: { label: 'Rosewood_Munich', bkn: 'ROW_BKN', inf: 'ROW_INF' },
  product13: { label: 'Bayerischer_Hof', bkn: 'BHF_BKN', inf: 'BHF_INF' },
  product14: { label: 'MUC_Airport_Luggage_Storage', bkn: 'FMG_BKN', inf: 'FMG_INF' },
} as const;
